export default {title:'Standards & Conditions'};